import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import YachtSlider from "../Components/YachtSlider";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";

export default function Deals() {
const API_URL = process.env.REACT_APP_API_BASE_URL;
   const Img_URL = process.env.REACT_APP_Img_BASE_URL;
const [boatData, setBoatData] = useState([]);
  const [sliders, setSliders] = useState([]);
   const [activeIndex, setActiveIndex] = useState(0);
useEffect(() => {
    const fetchBoats = async () => {
      try {
        const res = await fetch(`${API_URL}Boat/GetBoatMaster`);
        const data = await res.json();
        if (data.success) {
          setBoatData(data.data);
        }
      } catch (err) {
        console.error("Error fetching boats:", err);
      }
    };

    fetchBoats();
  }, []);

  
  const groupedBoats = boatData.reduce((acc, item) => {
  const key = item.subCategoryName || "Other";

  if (!acc[key]) {
    acc[key] = {
      boats: [],
      categoryName: item.categoryName,
      locationName: item.locationName,
      placeName: item.placeName,
      typeOfBoatName: item.typeOfBoatName,
      typeOfYachtName: item.typeOfYachtName,
    };
  }

  if (acc[key].boats.length < 10) {
  const imageUrl = item.boatMaster?.primeryImage
    ? `http://uat.indiaboats.in/images/Boat/${item.boatMaster.primeryImage}`
    : "http://uat.indiaboats.in/assets/img/boat1.jpg";

  acc[key].boats.push({
    id: item.boatMaster?.id || 0,
    title: item.boatMaster?.boatName || "No Name",
    desc: `${item.locationName || ""} - ${item.placeName || ""}`,
    img: imageUrl,
  });
}

  return acc;
}, {});

  return (
    <>
      {/* <Header /> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />
      <section className="container" style={{ padding: "50px 0" }}>
       
{Object.entries(groupedBoats).map(([subCategory, group]) => (
  <section
    key={subCategory}
    className="tour-area space"
    
  >
    <div className="container">

      <div className="text-center">

        {/* ✅ Sub Category */}
        <h3 className="sec-title" id="sec_title_slider">
          {subCategory} <span>({group.boats.length} Boats)</span>
        </h3>

        {/* ✅ Category */}
        <h4>{group.categoryName}</h4>

        {/* ✅ Location + Place */}
        <p>
          {group.locationName} - {group.placeName}
        </p>

        {/* ✅ Type Info */}
        <p>
          {group.typeOfBoatName} | {group.typeOfYachtName}
        </p>

      </div>

      {/* ✅ Slider */}
      <YachtSlider data={group.boats} />

    </div>
  </section>
))}
       
      </section>
      <Footer />
    </>
  );
}
